import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';

import { SwiperComponent }   from '../swiper.component';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        SwiperComponent
    ],
    declarations: [
        SwiperComponent
    ],
    providers: []
})
export class SwiperModule { }



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/swiper/module/swiper.module.ts